var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgDnd = function SvgDnd(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg8",
    width: 6,
    height: 10,
    viewBox: "0 0 1.587 2.646",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(0 -294.35)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g891",
    fill: "currentColor",
    stroke: "#aaa",
    strokeWidth: 0.529
  }, /*#__PURE__*/React.createElement("path", {
    id: "path856",
    fill: "currentColor",
    d: "M0 296.74h1.588"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path856-6",
    fill: "currentColor",
    d: "M0 295.68h1.588"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path856-6-7",
    fillOpacity: 0,
    d: "M0 294.62h1.588"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDnd);
export default ForwardRef;